/* TODO: Remove this once helptips are provided by confluence.
 * This file is a modified version of the one in https://bitbucket.org/atlassian/jira-help-tips.
 * Once help-tips are added to confluence we should be able to remove this file and use AJS.HelpTip instead.
 * However make sure that the AUI version is positioning things correctly in the editor before you do this.
 */

// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import window from 'window-or-global';
import { CONTEXT_PATH } from '@confluence-classic/confluence-urls';

// eslint-disable-next-line no-restricted-syntax, @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import './helptip-component.css';

function nope() {
	return false;
}
function yep() {
	return true;
}

let cidCounter = 0;
const seed = new Date().getTime();

// to un-fuck graphite event names
function cleanAnalyticsName(name) {
	name = `${name || ''}`;
	return name.replace(/\./g, '-');
}

function analytics(eventId, model) {
	if (window.AJS.EventQueue && model && model.attributes.id) {
		const event = {};
		const cleanId = cleanAnalyticsName(model.attributes.id);
		event.name = `helptips.${cleanId}.${eventId}`;
		event.properties = {};
		window.AJS.EventQueue.push(event);
	}
}

function getCid() {
	return `c${seed}${cidCounter++}`;
}

const Manager = {
	dismissedTipIds: [],
	loaded: $.Deferred(),
	url() {
		// TEAMCAL : make sure we use the calendar util component instead of ref to static method like this
		return `${CONTEXT_PATH}/rest/calendar-services/1.0/tips`;
	},
	sync(verb, data) {
		verb || (verb = 'get');
		data || (data = null);
		return $.ajax(this.url(), {
			type: verb,
			context: this,
			dataType: 'json',
			contentType: 'application/json',
			data: data && JSON.stringify(data),
			processData: false,
		}).promise();
	},
	fetch() {
		if (!window.AJS.Meta.get('atlassian-account-id')) {
			return;
		}

		const result = this.sync();
		result.done(function (response) {
			$.merge(this.dismissedTipIds, response);
			this.loaded.resolve();
		});
		return result.promise();
	},
	show(showFunction) {
		this.loaded.done(showFunction);
	},
	dismiss(tip) {
		const id = tip.attributes.id;
		if (!id) {
			tip._dismissed = true;
		} else {
			this.dismissedTipIds.push(id);
			this.sync('post', { id });
		}
	},
	undismiss(tip) {
		const id = tip.attributes.id;
		if (!id) {
			tip._dismissed = false;
		} else {
			this.dismissedTipIds.splice($.inArray(id, this.dismissedTipIds), 1);
			this.sync('delete', { id });
		}
	},
	isDismissed(tip) {
		const id = tip.attributes.id;
		return id ? $.inArray(id, this.dismissedTipIds) >= 0 : tip._dismissed;
	},
};

const HelpTip = function (attributes) {
	this.attributes = $.extend({}, attributes);
	this.attributes.id || (this.attributes.id = false);
	// Map renamed attribute body to bodyHtml
	if (this.attributes.body) {
		this.attributes.bodyHtml = this.attributes.body;
		delete this.attributes.body;
	}
	this.cid = getCid();
	const anchor = this.attributes['anchor'];
	delete this.attributes['anchor'];

	this.view = anchor ? new AnchoredView(this, anchor) : new UnanchoredView(this);
	this.view.$el.addClass('tc-aui-help-tip');
};

$.extend(HelpTip.prototype, {
	show() {
		const self = this;
		Manager.show(() => {
			if (!self.isDismissed()) {
				self.view.show();
				analytics('shown', self);
			}
		});
	},
	dismiss() {
		const reason = cleanAnalyticsName(arguments[0] || 'programmatically');
		this.view.dismiss();
		if (!this.isDismissed()) {
			Manager.dismiss(this);
			analytics(`dismissed.${reason}`, this);
		}
	},
	isVisible() {
		return this.view.$el.is(':visible');
	},
	isDismissed() {
		return Manager.isDismissed(this);
	},
});

const htmlTipClose = (translate) => `
    <button class="tc-helptip-close aui-button aui-style"><span>${translate(
			'com.atlassian.confluence.extra.team-calendars.calendar.helptip.close',
		)}</span></button>
`;

/**
 *
 * @param props
 *    bodyHtml (String) the html contents of the tip.
 *    ? title (String) a short name for the tip.
 *    ? url (String) a hyperlink to documentation for further info.
 * @param translate
 * @returns {string}
 */
const htmlTipContent = (props, translate) => {
	let html = '';
	if (props.title) {
		html += `<h4 class="tc-helptip-title">${props.title}</h4>`;
	}
	html += `<div class="tc-helptip-body">${props.bodyHtml}</div>`;
	if (props.url) {
		html += `<a class="tc-helptip-link" href="${
			props.url
		}" target="_blank">${translate('calendar3.helptip.learn.more')}</a>`;
	}
	return html;
};

let AnchoredView = function (model, anchor) {
	this.initialize(model, anchor);
};

$.extend(AnchoredView.prototype, {
	initialize(model, anchor) {
		const self = this;
		const arrowHeight = 9;
		const editorSpace = $('#rte').height() - anchor.offset().top;
		const minEditorSpace = 200;
		const flipDialog = editorSpace < minEditorSpace;
		const scrollPos = $(window.AJS.Rte.getEditor().getDoc()).scrollTop();
		this.model = model;
		this.beforeHide = nope;
		this.closeButton = $(htmlTipClose((s) => window.tinymce.activeEditor.translate(s)));
		this.closeButton.click((e) => {
			model.dismiss('close-button');
			e.preventDefault();
		});
		this.popup = window.AJS.InlineDialog(
			anchor,
			model.cid,
			(content, trigger, show) => {
				content.html(
					htmlTipContent(model.attributes, (s) => window.tinymce.activeEditor.translate(s)),
				);
				content.append(self.closeButton);
				content.unbind('mouseover mouseout');
				content.find('.tc-helptip-link').click(() => {
					analytics('learn-more.clicked', model);
				});
				show();
			},
			{
				// Use a container other than body, so that the positioning works when there are client-rendered banner messages
				container: '#content',
				noBind: true,
				onTop: flipDialog,
				preHideCallback() {
					return self.beforeHide();
				},
				calculatePositions(popup, targetPosition, mousePosition, opts) {
					// Adjust positions relative to the editor
					const cssData = window.AJS.InlineDialog.opts.calculatePositions(
						popup,
						targetPosition,
						mousePosition,
						opts,
					);

					if (flipDialog) {
						cssData.popupCss.top =
							$('#rte').offset().top + anchor.offset().top - popup.height() - arrowHeight;
					} else {
						cssData.popupCss.top =
							$('#rte').offset().top +
							(anchor.offset().top - scrollPos) +
							anchor.height() +
							arrowHeight;
					}

					cssData.popupCss.left = anchor.offset().left;
					cssData.displayAbove = flipDialog;

					return cssData;
				},
			},
		);
		this._popupHide = this.popup.hide;
		this.popup.hide = nope;
		this.$el = $(this.popup[0]);
		$(document).bind('showLayer', (e, type, layer) => {
			if (type === 'inlineDialog' && layer.id === model.cid) {
				window.AJS.InlineDialog.current = null; // Tips shouldn't be considered InlineDialogs.
				$(document.body).unbind(`click.${model.cid}.inline-dialog-check`);
				layer._validateClickToClose = nope;
				layer.hide = nope;
			}
		});
	},
	show() {
		const popup = this.popup;

		const hidePopup = function (e) {
			if (!popup.has(e.target).length) {
				popup.shadow.remove(); //Needed for IE
				popup.remove();
			}
		};

		popup.show();

		//Hide the help tip if it the user clicks outside of it.
		$('#full-height-container').click(hidePopup);

		//Hide the helptip inside the iframe
		window.AJS.Rte.getEditor().onClick.add(hidePopup);
	},
	dismiss() {
		this.beforeHide = yep;
		this._popupHide();
	},
});

let UnanchoredView = function (model) {
	this.initialize(model);
};

$.extend(UnanchoredView.prototype, {
	initialize() {
		this.$el = $('<div></div>');
	},
	show() {},
	dismiss() {},
});

export default () => {
	if (typeof window.Confluence.TeamCalendars === 'undefined') {
		window.Confluence.TeamCalendars = {};
	}

	window.Confluence.TeamCalendars.HelpTip = HelpTip; // TODO: Is this needed somewhere else?

	window.Confluence.TeamCalendars.HelpTip.Manager = Manager; // TODO: Is this needed somewhere else?

	// Load up the user's dismissed tips.
	Manager.fetch();
};
